export default {
  BASE_URL: process.env.REACT_APP_BACKEND_BASE_URL ?? 'http://localhost:8040'
};